<template>
  <div class="home">
<AlarmaNavar/>
<BannerAlarma/>
<CategoriasAlarma/>
<AlarmaFqa/>
<FooterSection/>
  </div>
</template>

<script>
import AlarmaNavar from '@/components/alarmas/AlarmaNavar.vue';
import BannerAlarma from '@/components/alarmas/BannerAlarma.vue';
import CategoriasAlarma from '@/components/alarmas/CategoriasAlarma.vue';
import AlarmaFqa from '@/components/alarmas/AlarmaFqa.vue';
import FooterSection from '@/components/FooterSection.vue';


export default {                                                                                                            
  name: 'TelefonoView',
  components: {
    AlarmaNavar,
    BannerAlarma,
    CategoriasAlarma,
    AlarmaFqa,
FooterSection,
  }
}
</script>